import { render, staticRenderFns } from "./Cedeflaw.vue?vue&type=template&id=2ac0adc7&scoped=true"
import script from "./Cedeflaw.vue?vue&type=script&lang=js"
export * from "./Cedeflaw.vue?vue&type=script&lang=js"
import style0 from "./Cedeflaw.vue?vue&type=style&index=0&id=2ac0adc7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac0adc7",
  null
  
)

export default component.exports